import { injectable } from 'tsyringe';
import { authClient } from '@/shared/AuthApiClient';

export interface TenantView {
    id: string;
    name: string;
    slug: string;
    status: string;
    memberCount: number;
    createdAt: string;
    updatedAt: string;
}

@injectable()
export class TenantsAdminService {
    async listTenants(): Promise<TenantView[]> {
        const data = await authClient.tenantsApi.getTenants();
        return data as unknown as TenantView[];
    }
}
